import {useAuth} from '../context/Auth'

export default function Logout() {
  const {logout} = useAuth()

  logout()
  return null
}
